import { withStyles } from '@material-ui/core';
import StyledToolTip from '../../../../../common/StyledToolTip';
import ScheduleIcon from '@material-ui/icons/Schedule';

const styles = (theme) => ({
  labelValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    display: 'flex',
    flexFlow: 'row wrap'
  },
  label: {
    color: theme.iconColor,
    fontSize: 10,
    fontWeight: 400,
    textTransform: 'uppercase'
  },
  negativeValue: { color: theme.error },
  positiveValue: {
    color: theme.HeaderSelectedText
  },
  stopValueContainer: {
    padding: '0px 4px',
    alignItems: 'center'
  },
  plannedContainer: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  iconClass: {
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    paddingRight: 2
  }
});

const StopLabelValue = ({ classes, planned, label, actual, showPlannedIcon = false }) => {
  return (
    <div className={classes.stopValueContainer}>
      <div className={classes.label}>{label}</div>
      <div className={classes.labelValue}>
        {actual && (
          <>
            <StyledToolTip title={actual.toolTip}>
              <span
                className={
                  actual.isPositiveValue || actual.value === 0
                    ? classes.positiveValue
                    : classes.negativeValue
                }>
                {actual.value}
              </span>
            </StyledToolTip>
            {' | '}
          </>
        )}
        <StyledToolTip title={planned.toolTip}>
          <div className={classes.plannedContainer}>
            {showPlannedIcon && <ScheduleIcon className={classes.iconClass} />}
            {planned.value}
          </div>
        </StyledToolTip>
      </div>
    </div>
  );
};

export default withStyles(styles)(StopLabelValue);
